var map = {
	"./AED.svg": 1711,
	"./AFN.svg": 3752,
	"./ALL.svg": 9372,
	"./AMD.svg": 6487,
	"./ANG.svg": 5961,
	"./AOA.svg": 5248,
	"./ARS.svg": 4801,
	"./AUD.svg": 5855,
	"./AWG.svg": 5126,
	"./AZN.svg": 2508,
	"./BAM.svg": 1225,
	"./BBD.svg": 2505,
	"./BDT.svg": 8759,
	"./BGN.svg": 9776,
	"./BHD.svg": 5787,
	"./BIF.svg": 8266,
	"./BMD.svg": 8396,
	"./BND.svg": 133,
	"./BOB.svg": 7660,
	"./BRL.svg": 2529,
	"./BSD.svg": 2646,
	"./BTC.svg": 7848,
	"./BTN.svg": 5517,
	"./BWP.svg": 7686,
	"./BYN.svg": 2690,
	"./BZD.svg": 5105,
	"./CAD.svg": 1373,
	"./CDF.svg": 8164,
	"./CHF.svg": 528,
	"./CLF.svg": 5868,
	"./CLP.svg": 4242,
	"./CNH.svg": 4012,
	"./CNY.svg": 4589,
	"./COP.svg": 9671,
	"./CRC.svg": 8139,
	"./CUC.svg": 9798,
	"./CUP.svg": 6373,
	"./CVE.svg": 5249,
	"./CZK.svg": 5547,
	"./DJF.svg": 4653,
	"./DKK.svg": 8203,
	"./DOP.svg": 8516,
	"./DZD.svg": 2639,
	"./EEK.svg": 2100,
	"./EGP.svg": 5077,
	"./ERN.svg": 2896,
	"./ETB.svg": 686,
	"./EUR.svg": 8637,
	"./FJD.svg": 5949,
	"./FKP.svg": 918,
	"./GBP.svg": 4492,
	"./GEL.svg": 8661,
	"./GGP.svg": 3531,
	"./GHS.svg": 897,
	"./GIP.svg": 493,
	"./GMD.svg": 1061,
	"./GNF.svg": 2894,
	"./GTQ.svg": 7287,
	"./GYD.svg": 1617,
	"./HKD.svg": 296,
	"./HNL.svg": 839,
	"./HRK.svg": 5572,
	"./HTG.svg": 2222,
	"./HUF.svg": 2984,
	"./IDR.svg": 8890,
	"./ILS.svg": 4963,
	"./IMP.svg": 3411,
	"./INR.svg": 1660,
	"./IQD.svg": 7283,
	"./IRR.svg": 1336,
	"./ISK.svg": 1790,
	"./JEP.svg": 1008,
	"./JMD.svg": 5844,
	"./JOD.svg": 4874,
	"./JPY.svg": 8398,
	"./KES.svg": 5614,
	"./KGS.svg": 4340,
	"./KHR.svg": 3204,
	"./KMF.svg": 4699,
	"./KPW.svg": 4321,
	"./KRW.svg": 8367,
	"./KWD.svg": 2779,
	"./KYD.svg": 7597,
	"./KZT.svg": 9764,
	"./LAK.svg": 1653,
	"./LBP.svg": 2323,
	"./LKR.svg": 3098,
	"./LRD.svg": 8095,
	"./LSL.svg": 5012,
	"./LYD.svg": 7562,
	"./MAD.svg": 4223,
	"./MDL.svg": 6320,
	"./MGA.svg": 8607,
	"./MKD.svg": 5149,
	"./MMK.svg": 6596,
	"./MNT.svg": 5974,
	"./MOP.svg": 3909,
	"./MRO.svg": 7865,
	"./MRU.svg": 7635,
	"./MUR.svg": 3061,
	"./MVR.svg": 1888,
	"./MWK.svg": 3094,
	"./MXN.svg": 750,
	"./MYR.svg": 6585,
	"./MZN.svg": 9456,
	"./NAD.svg": 7540,
	"./NGN.svg": 4860,
	"./NIO.svg": 9511,
	"./NOK.svg": 9897,
	"./NPR.svg": 9,
	"./NZD.svg": 3941,
	"./OMR.svg": 6307,
	"./PAB.svg": 4944,
	"./PEN.svg": 4504,
	"./PGK.svg": 3307,
	"./PHP.svg": 1525,
	"./PKR.svg": 3678,
	"./PLN.svg": 4471,
	"./PYG.svg": 5781,
	"./QAR.svg": 5013,
	"./RON.svg": 3192,
	"./RSD.svg": 358,
	"./RUB.svg": 6874,
	"./RWF.svg": 5896,
	"./SAR.svg": 6275,
	"./SBD.svg": 1556,
	"./SCR.svg": 8041,
	"./SDG.svg": 4565,
	"./SEK.svg": 7726,
	"./SGD.svg": 2307,
	"./SHP.svg": 5182,
	"./SLL.svg": 6278,
	"./SOS.svg": 244,
	"./SRD.svg": 6084,
	"./STD.svg": 2662,
	"./SVC.svg": 3391,
	"./SYP.svg": 4601,
	"./SZL.svg": 7604,
	"./THB.svg": 5339,
	"./TJS.svg": 4288,
	"./TMT.svg": 6606,
	"./TND.svg": 3131,
	"./TOP.svg": 5780,
	"./TRY.svg": 3730,
	"./TTD.svg": 8137,
	"./TWD.svg": 2752,
	"./TZS.svg": 8608,
	"./UAH.svg": 6643,
	"./UGX.svg": 13,
	"./USD.svg": 6589,
	"./UYU.svg": 5486,
	"./UZS.svg": 557,
	"./VEF.svg": 1274,
	"./VES.svg": 5415,
	"./VND.svg": 8937,
	"./VUV.svg": 1210,
	"./WST.svg": 787,
	"./XAF.svg": 788,
	"./XCD.svg": 3936,
	"./XOF.svg": 8366,
	"./XPF.svg": 4555,
	"./YER.svg": 89,
	"./ZAR.svg": 4278,
	"./ZMK.svg": 483,
	"./ZMW.svg": 279,
	"./ZWL.svg": 2490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1723;